export const faqs = [
  {
    q: "What ages do you treat?",
    a: "We focus on primary and secondary school-aged children. Please contact us to discuss specific age ranges for your school.",
  },
  {
    q: "Which areas do you service?",
    a: "We visit schools across metropolitan and regional Australia. Availability depends on scheduling and travel — please get in touch and we'll let you know how we can help.",
  },
  {
    q: "How does a school book a visit?",
    a: "A school representative can complete the enquiry form on our 'For Schools' page or contact us by phone or email. We'll organise a call to understand your needs and confirm dates.",
  },
  {
    q: "Is parental consent required?",
    a: "Yes. Written parental or guardian consent is required before any child receives an examination or treatment. We provide consent forms that schools can distribute to families.",
  },
  {
    q: "What services are available on the day?",
    a: "Services typically include check-ups, cleans, fluoride treatments, fissure sealants and oral-health education. Availability of specific services depends on clinical assessment, consent and equipment on the day.",
  },
  {
    q: "Do you do dental fillings on the van?",
    a: "Where a cavity is identified during examination and can be safely treated in the mobile clinic setting, we may provide simple, tooth-coloured fillings. Fillings are only performed with informed consent from a parent or guardian, and more complex restorative work is referred to a suitable local dental provider.",
  },
  {
    q: "What happens if my child has gum disease?",
    a: "Our clinicians check the health of your child's gums at every visit. If early signs of gingivitis or gum inflammation are found, we may provide a gentle clean and tailored home-care advice, and include recommendations in the parent report. Where further periodontal care is needed, we'll help with a referral to a local provider.",
  },
  {
    q: "How long does an appointment take?",
    a: "Most standard appointments take around 15–30 minutes, depending on the services provided. We work with schools to minimise disruption to lessons.",
  },
  {
    q: "Will parents receive a report?",
    a: "Yes. After each visit, parents receive a plain-English summary of what was performed and any recommended next steps.",
  },
  {
    q: "What happens if further treatment is needed?",
    a: "If a child needs additional care beyond what can be provided in the mobile clinic, we'll include recommendations in the report and, where helpful, assist with a referral to a local dental provider.",
  },
  {
    q: "Is treatment covered by Medicare?",
    a: "Some children may be eligible under the Child Dental Benefits Schedule (CDBS). Eligibility and coverage must be confirmed directly with Medicare or with our team. We are unable to guarantee coverage in individual circumstances.",
  },
  {
    q: "How are privacy and health records handled?",
    a: "Health information is handled in accordance with Australian privacy laws and clinical record-keeping requirements. Please see our Privacy Policy for more information.",
  },
  {
    q: "What infection-control procedures are followed?",
    a: "Our team follows standard clinical infection-control procedures for instrument cleaning, sterilisation and surface disinfection between patients.",
  },
  {
    q: "Can parents contact the clinic directly?",
    a: "Absolutely. Parents are welcome to contact us via the details on our Contact page with any questions before or after a visit.",
  },
];
